import { type ChangeTeamStatusValue } from '@/api/changeTeamStatusValue.ts'

import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface CancelTransportRequestApiVariables {
  regionId: string
  transportRequestId: string
  teamStatus?: ChangeTeamStatusValue // required when team is assigned to request
}

export const useCancelTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, CancelTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, CancelTransportRequestApiVariables>({
    type: 'piloteCancelTransportRequest',
    ...options,
  })
